import productsFieldsQuery from '../domain/types/graphql/fields/products'
import linkedProductsFieldsQuery from '../domain/types/graphql/fields/linkedProducts'
import promotionsFieldsQuery from '../domain/types/graphql/fields/promotions'
import { gql } from './gql'

/**
 * Get catalog fields
 * @internal
 */
export const catalogFieldsQuery: string = `
  category
  priority
  productsPrices {
    ${productsFieldsQuery}
  }
 `

/**
 * Get's the string for `catalog` query.
 * This query gets all existing items in the catalog.
 */
export const GET_CATALOG = gql`
  query Catalog(
      $catalogStorefrontName: String!,
      $catalogSessionId: String!,
      $categoryName: String,
      $pagination: PaginationInput,
      $totalPromotionsSessionId: ID!
      $groupCategories: Boolean
      $showChildrenCategories: Boolean
      $showHiddenCategories: Boolean
    ) {
    catalog(
      storefrontName: $catalogStorefrontName,
      sessionUid: $catalogSessionId,
      category: $categoryName,
      pagination: $pagination,
      groupCategories: $groupCategories
      showChildrenCategories: $showChildrenCategories
      showHiddenCategories: $showHiddenCategories
    ) {
      category
      priority
      parentId
      productsPrices {
        ${productsFieldsQuery}
        ${linkedProductsFieldsQuery}
      }
    }
    getTotalPromotions(storefrontName: $catalogStorefrontName, sessionUid: $totalPromotionsSessionId) {
      ${promotionsFieldsQuery}
    }
  }
`
